import React from 'react';
import dayjs from 'dayjs';
import { Box, Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../../utils/numberUtils';

const EstimateDetailsContainer = ({ project, estimate }) => {
  if (!estimate) {
    return null;
  }

  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적 번호
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteNo}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적일자
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteRegDt
              ? estimate?.qteRegDt
              : dayjs(estimate?.crtDt).format('YYYY-MM-DD')}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적 유효일자
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteValidDt}
          </Typography>
        </Grid>
        <Grid item xs={4} />
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            담당자명
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteUsrNm}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            담당자 연락처
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteUsrTel}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            담당자 이메일
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.qteUsrEml}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            총 견적 금액
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {getNumberComma(estimate?.qtePrice)}원
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            유지보수기간
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" component="div">
            {estimate?.mntTor} 개월
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            납품 장소
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.destPlace}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            발행 조건
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.qteCondt}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            결제 조건
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.payCond}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적서 설명 1
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc1}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적서 설명 2
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc2}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            견적서 설명 3
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc3}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EstimateDetailsContainer;
